export const HEADER_LABEL_URL_MAP = {
  ROOT: {
    label: 'Home',
    test: (url: string) => url === '/',
  },
  GIFT_CARDS: { label: 'Gift Cards Admin Dashboard', test: (url: string) => url.startsWith('/gift-cards') },
  PHYSICAL_ORDERS: { label: 'Physical Operations', test: (url: string) => url.startsWith('/physical-orders') },
  DGC_ORDERS: { label: 'DGC Operations', test: (url: string) => url.startsWith('/dgc-orders') },
};
